import React from 'react';
import Menu, { MenuProps } from '@lib/components/Menu/Menu';
import Popover, { PopoverProps } from '@lib/components/Popover/Popover';
import IconButton, {
  IconButtonProps,
} from '@lib/components/IconButton/IconButton';
import styles from './IconButtonWithDropDown.module.scss';

type Props<T> = {
  buttonProps?: IconButtonProps;
  popoverProps?: Omit<PopoverProps, 'children' | 'body'>;
  className?: string;
  navItems: MenuProps<T>['navItems'];
};

export default function IconButtonWithDropDown<T>(props: Props<T>) {
  const { buttonProps, popoverProps, className, navItems } = props;
  const popoverBody = () => (
    <div className={styles.popoverBody}>
      <Menu navItems={navItems} itemClassName={styles.menuItemClassName} />
    </div>
  );
  return (
    <div className={className}>
      <Popover {...popoverProps} body={popoverBody}>
        {({ handleToggle, isOpen }) => (
          <div>
            <IconButton
              {...buttonProps}
              onClick={() => handleToggle()}
              isFocused={isOpen}
            />
          </div>
        )}
      </Popover>
    </div>
  );
}
